<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <el-tabs v-model="activedTab" class="tabpane-mode2" @tab-click="allotTabClick">
          <el-tab-pane label="分配管理" name="allotManagement"></el-tab-pane>
          <el-tab-pane label="计划任务" name="allotTaskSchedule"></el-tab-pane>
        </el-tabs>
        <el-card>
          <div slot="header" class="clearfix">
            <span>添加老师</span>
          </div>
          <el-form :inline="true">
            <el-form-item label="教师">
              <el-select v-model="teacherId" clearable placeholder="请选择" filterable>
                <el-option-group v-for="(group, k) in trainingTeachers" :key="k" :label="k">
                  <el-option v-for="item in group" :key="`${item.country}_${item.userid}`" :label="item.truename"
                             :value="item.userid" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addTeacher">添加</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <jm-table-list url="/training/allot_management/teacherList" :refresh.sync="refresh" row-key="id"
                       :search-data="searchData" :page-size.sync="pageSize">
          <el-table-column fixed="right" slot="lastColumn" label="操作" class-name="scope-button-list">
            <template slot-scope="scope">
              <el-button type="primary" @click="openEditDialog(scope.row)">编辑</el-button>
              <el-button type="danger" @click="deleteTeacher(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </jm-table-list>

        <!--编辑弹窗 start-->
        <el-dialog title="信息修改" :visible.sync="editLock" width="600px">
          <el-form :model="editForm">
            <el-form-item label="分配数量：" :label-width="formLabelWidth">
              <el-input class="jm-input400" v-model="editForm.nums" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editLock = false">取 消</el-button>
            <el-button type="primary" @click="editFormSubmit">确 定</el-button>
          </div>
        </el-dialog>
        <!--编辑弹窗 end-->
      </div>
    </div>
  </div>
</template>
<script>
import jmTableList from '@/components/data/tableList';
import student from '@/pages/student/student';

export default {
  mixins: [student],
  name: 'AllotManager',
  components: {
    jmTableList,
  },
  data() {
    return {
      activedTab: 'allotManagement',
      teacherId: null,
      pageSize: 50,
      searchData: {},
      refresh: false,
      editLock: false,
      formLabelWidth: '150',
      editForm: {
        nums: ''
      },
    };
  },
  computed: {
    trainingTeachers() {
      return this.ds.training_teacher;
    },
  },
  methods: {
    allotTabClick(tab) {
      console.info(tab.name);
      if (tab.name === 'allotTaskSchedule') {
        this.$router.push({ name: 'allotTaskSchedule' });
      }
    },
    openEditDialog(row) {
      this.editLock = true;
      this.editForm = JSON.parse(JSON.stringify(row));
    },
    editFormSubmit() {
      this.$http._post({
        url: '/training/allot_management/saveTeacher',
        data: { ...this.editForm }
      }).then(() => {
        this.editLock = false;
        this.$message.success('修改成功');
        this.refresh = true;
      });
    },
    async deleteTeacher(id) {
      try {
        await this.$confirm('确定要删除？', '删除分配老师');
      } catch (error) {
        return false;
      }
      try {
        await this.$http._delete({
          url: `/training/allot_management/delTeacher/id/${id}`,
        });
        this.$message.success('删除成功');
        this.refresh = true;
      } catch (error) {
        console.error(error);
      }
    },
    async addTeacher() {
      try {
        await this.$http._post({
          url: '/training/allot_management/addTeacher',
          data: { userId: this.teacherId },
        });
        this.$message.success('添加成功');
        this.refresh = true;
      } catch (error) {
        console.error(error);
      }
    },
  },
  created() {
    this.getDatasource();
  },
  mounted() {},
};
</script>
